import React, { useState, Children } from 'react';
import { Reservation } from '../types/Reservation';
import { SearchIcon, FilterIcon } from 'lucide-react';
export function Reservations() {
  // Mock data based on the screenshot
  const [reservations, setReservations] = useState<Reservation[]>([{
    id: '1',
    pnr: '3Y6TE994',
    dateCreated: '27 September 2025 at 17:14',
    checkInDate: '09 Oct 2025',
    checkOutDate: '10 Oct 2025',
    mainGuest: 'Simon Verraest',
    guests: {
      adults: 2,
      children: 0,
      infants: 0
    },
    total: '$1.29',
    status: 'confirmed'
  }, {
    id: '2',
    pnr: 'FRUJDGE',
    dateCreated: '26 September 2025 at 17:08',
    checkInDate: '10 Nov 2025',
    checkOutDate: '11 Nov 2025',
    mainGuest: 'Ahmed Waleed',
    guests: {
      adults: 2,
      children: 0,
      infants: 0
    },
    total: '$1.29',
    status: 'confirmed'
  }, {
    id: '3',
    pnr: 'DERUVIM34',
    dateCreated: '25 September 2025 at 19:15',
    checkInDate: '28 Sep 2025',
    checkOutDate: '29 Sep 2025',
    mainGuest: 'Simon Verraest',
    guests: {
      adults: 2,
      children: 0,
      infants: 0
    },
    total: '$1.29',
    status: 'confirmed'
  }]);
  // Search and filter state
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');
  // Filter reservations based on search term and status filter
  const filteredReservations = reservations.filter(reservation => {
    const matchesSearch = reservation.mainGuest.toLowerCase().includes(searchTerm.toLowerCase()) || reservation.pnr.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || reservation.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  // Format guest count for display
  function formatGuestCount(guests: {
    adults: number;
    children: number;
    infants: number;
  }): string {
    return `${guests.adults} Adults, ${guests.children} Children, ${guests.infants} Infants`;
  }
  // Navigate to reservation detail
  const navigateToDetail = (pnr: string) => {
    window.location.href = `/reservation-detail?pnr=${pnr}`;
  };
  return <div className="space-y-6" data-id="element-5440">
      <div className="flex justify-between items-center" data-id="element-5441">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-5442">Reservations</h1>
      </div>
      {/* Search and filters */}
      <div className="flex flex-wrap gap-3" data-id="element-5443">
        <div className="relative flex-grow max-w-xs" data-id="element-5444">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-5445">
            <SearchIcon size={16} className="text-gray-400" data-id="element-5446" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md" placeholder="Search reservations..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-5447" />
        </div>
        <select className="border border-gray-300 rounded-md px-3 py-2" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-5448">
          <option value="all" data-id="element-5449">Status</option>
          <option value="confirmed" data-id="element-5450">Confirmed</option>
          <option value="cancelled" data-id="element-5451">Cancelled</option>
          <option value="pending" data-id="element-5452">Pending</option>
        </select>
      </div>
      {/* Reservations Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto" data-id="element-5453">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-5454">
          <thead className="bg-gray-50" data-id="element-5455">
            <tr data-id="element-5456">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5457">
                Date created
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5458">
                PNR
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5459">
                Check-in Date
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5460">
                Check-out Date
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5461">
                Main Guest
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5462">
                Guests
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5463">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-5464">
            {filteredReservations.map(reservation => <tr key={reservation.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigateToDetail(reservation.pnr)} data-id="element-5465">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-5466">
                  {reservation.dateCreated}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-5467">
                  {reservation.pnr}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-5468">
                  {reservation.checkInDate}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-5469">
                  {reservation.checkOutDate}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-5470">
                  {reservation.mainGuest}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-5471">
                  {formatGuestCount(reservation.guests)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-5472">
                  {reservation.total}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}